<template>
  <section class="main">
    <div class="container pt-5 pb-5">
      <div class="row">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2 cursor-pointer" @click="Filtro('todos')">
          <div class="card mt-3 mt-md-0 border-0 position-relative" :class="{'bg-active': selectType === 'todos'}">
            <div class="card-body d-flex justify-content-between align-items-start flex-column">
                <div class="d-flex flex-row justify-content-between w-100">
                  <p>Todos</p> 
                </div>
                <div v-if="totalChamados > 0">
                  <div class="spinner-grow text-secondary" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <h2 class="tertiary" v-if="!loading">{{ totalChamados }}</h2>
                </div>
                <h5 v-else>
                  <h2 class="tertiary" v-if="!loading">0</h2>
                  <small v-if="!loading">Nenhum chamado registrado.</small>
                  <div class="spinner-grow" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                  </div>
                </h5>
              </div>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2 cursor-pointer" @click="Filtro('concluido')">
          <div class="card mt-3 mt-md-0 border-0 position-relative" :class="{'bg-active': selectType === 'concluido'}">
            <div class="card-body d-flex justify-content-between align-items-start flex-column">
                <div class="d-flex flex-row justify-content-between w-100">
                  <p>Total concluídos</p> 
                </div>
                <div v-if="totalConcluidos > 0">
                  <div class="spinner-grow text-secondary" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <h2 class="tertiary" v-if="!loading">{{ totalConcluidos }}</h2>
                </div>
                <h5 v-else>
                  <h2 class="tertiary" v-if="!loading">0</h2>
                  <small v-if="!loading">Nenhum chamado concluídos</small>
                  <div class="spinner-grow" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                  </div>
                </h5>
              </div>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2 cursor-pointer" @click="Filtro('pendente')">
          <div class="card mt-3 mt-md-0 border-0 position-relative" :class="{'bg-active': selectType === 'pendente'}">
            <div class="card-body d-flex justify-content-between align-items-start flex-column">
              <div class="d-flex flex-row justify-content-between w-100">
                <p class="mutted">Chamados pendentes</p>
              </div>
              <h2 v-if="loading"><div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div></h2>
              <h2 v-else class="tertiary">{{ totalPendentes }}</h2>
            </div>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2 cursor-pointer"  @click="Filtro('andamento')">
          <div class="card mt-3 mt-md-0 border-0 position-relative" :class="{'bg-active': selectType === 'andamento'}">
            <div class="card-body d-flex justify-content-between align-items-start flex-column">
              <div class="d-flex flex-row justify-content-between w-100">
                <p>Chamados em análise</p>
              </div>
              <h2 v-if="loading"><div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div></h2>
              <h2 v-else class="tertiary">{{ totalAndamento }}</h2>
            </div>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2 cursor-pointer" @click="Filtro('new')">
          <div class="card mt-3 mt-md-0 border-0 position-relative" :class="{'bg-active': selectType === 'new'}">
            <div class="card-body d-flex justify-content-between align-items-start flex-column">
              <div class="d-flex flex-row justify-content-between w-100">
                <p>Novos chamados</p>
              </div>
              <h2 v-if="loading"><div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div></h2>
              <h2 v-else class="tertiary">{{ totalNew }}</h2>
            </div>
          </div>
        </div>
      </div>
      <hr>
        <div class="row">
        <div class="col-12 text-left">
          <div class="row">
            <div class="form-row form_padrao  col-md-3">
                <div class="flutuante col-md-12 position-relative">
                  <select class="form-control"  @change="Filtro(selectType)" v-model="selectedYear">
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
              <div class="form-row form_padrao  col-md-3">
                <div class="flutuante col-md-12 position-relative">
                  <select class="form-control" v-model="typegraf">
                    <option value="line">Gráfico de Linha</option>
                    <option value="bar">Gráfico de Barra</option>
                  </select>
                </div>
              </div>
          </div>

        </div>
        <div class="col-12 chart-wrapper" v-if="chartOptions && chartSeries && !loading">
          <apexchart 
            :key="`chart-${selectType}-${typegraf}`"
            :type="typegraf" 
            :options="chartOptions" 
            :series="chartSeries"
            :height="'100%'"
          ></apexchart>
        </div>
        <div class="col-12 text-center" v-else-if="loading">
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Carregando gráfico...</span>
          </div>
        </div>
      </div>
      <!--
      <div class="row">
        <div class="col pt-5 d-md-flex d-inline text-center justify-content-between">
          <h2>Meus cursos ativos</h2>
          <router-link
            :to="{ name: 'addcurso' }"
            class="btn btn-tertiary mt-3 mt-md-0"
            >+ Publicar novo curso</router-link
          >
        </div> 
      </div>-->
    </div>
    <Dialog header="Cadastro realizado com sucesso!" :visible.sync="EditPassword" :modal="true"
        :breakpoints="{ '960px': '75vw', '640px': '80vw' }" :style="{ width: '80vw' }">
          <div class="card">
            <div class="card-header text-center bg-warning">
              <h4>Cadastro realizado com sucesso!</h4>
            </div>
            <div class="card-body text-center">
              <p style=" text-align: justify; ">
                Olá {{ $store.state.user.name }},
                <br>
                Seja bem-vindo à plataforma de atendimento!
                <br>
                <br>
                Para garantir a segurança dos seus dados, foi gerada uma senha automática para a sua conta. Recomendamos que você altere essa senha para uma de sua escolha o quanto antes. Para fazer isso, basta clicar no botão abaixo e seguir as instruções em sua conta.
              </p>
              <router-link role="tab" :to="{name: 'configuracoes'}" class="btn btn-primary btn-lg mb-2 mt-2">Alterar senha</router-link>
              <p style=" text-align: justify; ">
                Lembre-se de escolher uma senha forte e segura que inclua letras maiúsculas e minúsculas, números e caracteres especiais de no mínimo 8 caracteres. Não compartilhe a sua senha com ninguém e atualize-a regularmente.
                <br>
                Se você tiver alguma dúvida ou precisar de ajuda, nossa equipe de suporte está à disposição para ajudá-lo.
              </p>
            </div>
          </div>
      </Dialog>
  </section>
</template>
<script>
import Dialog from "primevue/dialog";
import VueApexCharts from 'vue-apexcharts'
export default {
  name: "HomeAtendente",
  components: {
    'apexchart': VueApexCharts,
    Dialog
  },
  data() {
    return {
      chartOptions: null,
      chartSeries: null,
      typegraf:'line',
      currentYear: new Date().getFullYear(), // Pega o ano atual
      selectedYear: new Date().getFullYear(),
      selectedOption:'mensal',
      selectType:'todos',
      dataGraf:[],

      loading: false,
      totalChamados:0, 
      totalConcluidos:0,
      totalPendentes:0,
      totalAndamento:0,
      totalNew:0,
      EditPassword:false,
    };
  },
  computed: {
    group() {
      return this.$store.state.user.group;
    },
    years() {
        let startYear = 2015;
        let years = [];
        for (let year = startYear; year <= this.currentYear; year++) {
          years.push(year);
        }
        return years;
      }
  },
  
  watch: {
    typegraf() {
      // Quando o tipo de gráfico muda, reaplica o filtro para atualizar as configurações
      this.Filtro(this.selectType);
    }
  },

  methods: {
    // Função para sanitizar dados e garantir que sejam números válidos
    sanitizeData(data) {
      if (!Array.isArray(data)) {
        return Array(12).fill(0);
      }
      
      return data.map(value => {
        const num = Number(value);
        return isNaN(num) || !isFinite(num) ? 0 : num;
      });
    },
    getRelatorios() {
      this.$http
        .get("/api/atendente/relatorios")
        .then((response) => 
        {
          this.totalChamados  = response.data["totalChamados"];
          this.totalConcluidos = response.data["totalConcluidos"];
          this.totalPendentes = response.data["totalPendentes"];
          this.totalAndamento = response.data["totalAndamento"];
          this.totalNew       = response.data["totalNew"];
          
          // Carrega o gráfico agregado por padrão (todos)
          this.Filtro('todos');

          this.loading = false;
        })
        .catch(() => {});
    },
    Filtro(selectType) {
      this.selectType = selectType;
      this.loading = true;
      
      // Se for "todos", criamos um gráfico com múltiplas linhas/barras
      if (selectType === 'todos') {
        const tipos = [
          { key: 'concluido', name: 'Concluídos', color: '#28a745' },
          { key: 'pendente', name: 'Pendentes', color: '#ffc107' },
          { key: 'andamento', name: 'Em Análise', color: '#17a2b8' },
          { key: 'new', name: 'Novos', color: '#6f42c1' }
        ];
        
        const promises = tipos.map(tipo => 
          this.$http.post("/api/atendente/FiltreCount", { 
            data: { 
              periodo: 'mensal',
              status: tipo.key,
              selectedYear: this.selectedYear
            } 
          })
        );
        
        Promise.all(promises)
          .then((responses) => {
            // Cria uma série para cada tipo de chamado com dados sanitizados
            this.chartSeries = tipos.map((tipo, index) => ({
              name: tipo.name,
              data: this.sanitizeData(responses[index].data),
              color: tipo.color
            }));
            
            // Calcula o valor máximo entre todas as séries sanitizadas
            const allValues = responses.flatMap(response => this.sanitizeData(response.data));
            const maxValue = Math.max(...allValues);
            const safeMaxValue = isNaN(maxValue) || !isFinite(maxValue) || maxValue <= 0 ? 10 : maxValue;
            
            this.chartOptions = {
              chart: {
                id: 'quantidade-por-mes-multiplas',
                height: '100%',
                width: '100%',
                toolbar: {
                  show: true
                }
              },
              colors: tipos.map(tipo => tipo.color),
              xaxis: {
                categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
              },
              yaxis: {
                max: safeMaxValue * 1.2
              },
              legend: {
                show: true,
                position: 'top'
              },
              stroke: {
                width: this.typegraf === 'line' ? 2 : 0,
                curve: 'smooth'
              },
              dataLabels: {
                enabled: false
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '55%',
                  endingShape: 'rounded'
                }
              }
            };
            
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        // Para seleções específicas, mantém comportamento de série única
        this.$http
          .post("/api/atendente/FiltreCount", { 
            data: { 
              periodo: 'mensal',
              status: this.selectType,
              selectedYear: this.selectedYear
            } 
          })
          .then((response) => {
            // Define cor baseada no tipo selecionado
            let color = '#007bff'; // cor padrão
            switch(this.selectType) {
              case 'concluido': color = '#28a745'; break;
              case 'pendente': color = '#ffc107'; break;
              case 'andamento': color = '#17a2b8'; break;
              case 'new': color = '#6f42c1'; break;
            }
            
            const sanitizedData = this.sanitizeData(response.data);
            
            this.chartSeries = [{
              name: this.getNomeCategoria(this.selectType),
              data: sanitizedData,
              color: color
            }];
            
            const maxValue = Math.max(...sanitizedData);
            const safeMaxValue = isNaN(maxValue) || !isFinite(maxValue) || maxValue <= 0 ? 10 : maxValue;
            
            this.chartOptions = {
              chart: {
                id: 'quantidade-por-mes-unica',
                height: '100%',
                width: '100%',
                toolbar: {
                  show: true
                }
              },
              colors: [color],
              xaxis: {
                categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
              },
              yaxis: {
                max: safeMaxValue * 1.2
              },
              legend: {
                show: false
              },
              stroke: {
                width: this.typegraf === 'line' ? 2 : 0,
                curve: 'smooth'
              },
              dataLabels: {
                enabled: false
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '55%',
                  endingShape: 'rounded'
                }
              }
            };
            
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    
    getNomeCategoria(tipo) {
      const nomes = {
        'concluido': 'Concluídos',
        'pendente': 'Pendentes', 
        'andamento': 'Em Análise',
        'new': 'Novos'
      };
      return nomes[tipo] || 'Chamados';
    },
  },
  mounted() {
    if(this.$store.state.user.text_password != '********'){
      this.EditPassword = true;
    }

    this.getRelatorios();
  },
};
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  min-height: 140px;
}
.bg-active {
  background-color: var(--primary); /* Substitua 'green' pela cor desejada */
}
.bg-active > div > div > p, .bg-active > div > div > h2, .bg-active > div > div > h5, .bg-active > div > h2, .bg-active > div > h5, .bg-active > div > h2, .bg-active > div > h5 > h2{
  color:white;
}
.chart-wrapper {
  height: 400px !important;
  width: 100%;
}
</style>